import React, {useEffect, useState} from "react";
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle, Grid,
    Table,
    TableCell,
    TableRow,
    TextField
} from "@material-ui/core";
//import DateTimePicker from "react-datetime-picker/src/DateTimePicker";
import CgSelect from "../core/CgSelect";
import axios from "axios";

export function SendTemplateDialog(props){
    const {goParameters} = props;
    const {onDock} = props;
    const [open,setOpen] = useState(false);
    const [from, setFrom] = useState(null);
    const [sendingTemplate, setSendingTemplate] = useState({});
    const [onOk, setOnOk] = useState(() => () => alert("no onOk set"));
    const show = (onOk) => {setOpen(true); setSendingTemplate({}); setOnOk(() => onOk)};

    useEffect(() => {
        onDock(show);
    },[]); // eslint-disable-line react-hooks/exhaustive-deps

    return <Dialog open={open} onclose={() => setOpen(false)}

    >
        <DialogTitle>Sending Scripts</DialogTitle>
        <DialogContent>
            <DialogContentText>

            </DialogContentText>
            <Grid container spacing={2}>
                <Grid item xs={6}>
                    <Table >
                        <TableRow>
                            <TableCell>Name</TableCell>
                            <TableCell>
                                <TextField style={{width:'300px'}} onChange={event => {
                                    setSendingTemplate({...sendingTemplate, name:event.target.value})
                                }} value={sendingTemplate.name}/>
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>Email</TableCell>
                            <TableCell>
                                <TextField style={{width:'300px'}} onChange={event => {
                                    setSendingTemplate({...sendingTemplate, email:event.target.value})
                                }} value={sendingTemplate.email}/>
                            </TableCell>
                            <TableCell>
                                <Button color='secondary' disabled={!(sendingTemplate.email)}
                                        onClick={() => {
                                            const url = 'api/phish/readTemplateLogForEmail/' + sendingTemplate.email;
                                            axios.get(url).then(response => {
                                                alert(JSON.stringify(response.data));
                                            })
                                                .catch(error => alert("error: " + error.message()));
                                        }}>Check</Button>
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>Email Account</TableCell>
                            <TableCell>
                                <CgSelect style={{ width: '300px' }} isMulti={false}
                                          options={(goParameters || []).map(p => p.from)}
                                          value={from}
                                          onChange={value => {
                                              setFrom(value);
                                              setSendingTemplate({...sendingTemplate, templates:''});
                                          }} />
                            </TableCell>

                        </TableRow>
                        <TableRow>
                            <TableCell>Email Tamplates</TableCell>
                            <TableCell>
                                <CgSelect style={{ width: '300px' }} isMulti={true}
                                          options={(goParameters.find(p => p.from === from) || {}).profiles || []}
                                          value={sendingTemplate.templates}
                                          onChange={value => {
                                              setSendingTemplate({...sendingTemplate, templates:value});
                                          }} />
                            </TableCell>

                        </TableRow>
                    </Table>
                </Grid>
                <Grid item xs={6}>

                </Grid>
            </Grid>

        </DialogContent>
        <DialogActions>
            <Button onClick={() => setOpen(false)}>Cancel</Button>
            <Button onClick={() => {
                if(!sendingTemplate){
                    alert('No Sending Tempalte');
                    return;
                }
                if(!sendingTemplate.templates){
                    alert('No Email Templates Specified');
                    return;
                }
                setOpen(false);
                onOk(sendingTemplate);
            }}>OK</Button>
        </DialogActions>
    </Dialog>
}